var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// aspect-schemas/ExistsAspect.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { nothing } from "lit";
import { AbstractAspect } from "./AbstractAspect.js";
var ExistsAspect = class extends AbstractAspect {
  constructor(doc) {
    super(doc);
  }
  getMongoFilter() {
    if (!this.fieldName)
      return null;
    return {
      $and: [
        { [this.fieldName]: { $ne: null } },
        { [this.fieldName]: { $exists: true } },
        { [this.fieldName]: { $ne: "" } },
        { [this.fieldName]: { $not: { $size: 0 } } }
      ]
    };
  }
};
ExistsAspect._class = "ExistsAspect";
__decorateClass([
  Field((type) => Boolean, { default: (v) => v ?? true })
], ExistsAspect.prototype, "value", 2);
ExistsAspect = __decorateClass([
  Entity()
], ExistsAspect);
var ExistsAspectConfig = {
  aspectConstructor: ExistsAspect,
  renderEditor: ({ aspectValue }) => nothing,
  renderPreview: ({ aspectValue, translation }) => nothing
};
var DoesNotExistAspect = class extends AbstractAspect {
  constructor(doc) {
    super(doc);
  }
  getMongoFilter() {
    if (!this.fieldName)
      return null;
    return {
      $or: [
        { [this.fieldName]: { $eq: null } },
        { [this.fieldName]: { $exists: false } },
        { [this.fieldName]: { $eq: "" } },
        { [this.fieldName]: { $size: 0 } }
      ]
    };
  }
};
DoesNotExistAspect._class = "DoesNotExistAspect";
DoesNotExistAspect = __decorateClass([
  Entity()
], DoesNotExistAspect);
var DoesNotExistAspectConfig = {
  aspectConstructor: DoesNotExistAspect,
  renderEditor: ({ aspectValue }) => nothing,
  renderPreview: ({ aspectValue, translation }) => nothing
};
export {
  DoesNotExistAspect,
  DoesNotExistAspectConfig,
  ExistsAspect,
  ExistsAspectConfig
};
